export const PAGE_ANCHORS_OBSERVERS_TYPES = ['VerticalAnchorsMenu']
export const ACTIVE_ANCHOR_OBSERVERS_TYPES = [
	'DropDownMenu',
	'TinyMenu',
	'StylableHorizontalMenu',
	'Menu',
	'ExpandableMenu',
]
